export const superAGIApps = {
  SUPER_SALES: "SuperSales",
  SUPER_SUPPORT: "SuperSupport",
  SUPER_MARKETING: "SuperMarketing",
  SUPER_WORKERS: "SuperWorkers",
  SUPER_ACADEMY: "SuperAcademy",
};

export const superAGIAppLinks = {
  [superAGIApps.SUPER_SALES]: window.location.href.includes("in.superagi.com")
    ? "https://sales.in.superagi.com/"
    : "https://sales.superagi.com/",
  [superAGIApps.SUPER_SUPPORT]: "https://support.superagi.com/",
  [superAGIApps.SUPER_MARKETING]: "https://marketing.superagi.com/",
  [superAGIApps.SUPER_WORKERS]: "https://workers.superagi.com/",
  [superAGIApps.SUPER_ACADEMY]: "https://academy.superagi.com/",
};

export const superAGIAppDetails = [
  {
    name: superAGIApps.SUPER_SALES,
    link: superAGIAppLinks[superAGIApps.SUPER_SALES],
    isSelected: true,
  },
  {
    name: superAGIApps.SUPER_SUPPORT,
    link: superAGIAppLinks[superAGIApps.SUPER_SUPPORT],
    isSelected: false,
  },
  {
    name: superAGIApps.SUPER_MARKETING,
    link: superAGIAppLinks[superAGIApps.SUPER_MARKETING],
    isSelected: false,
  },
  {
    name: superAGIApps.SUPER_WORKERS,
    link: superAGIAppLinks[superAGIApps.SUPER_WORKERS],
    isSelected: false,
  },
];

export const demoLink = "https://meetings.superagi.com/Sales-Demo-Team";

export const onboardingVideoEmbedLink =
  "https://www.youtube.com/embed/vUWFm87918A?autoplay=0&rel=0&modestbranding=1";

export const mobileAppInfo = {
  androidLink: window.location.href.includes("in.superagi.com")
    ? "https://sales.in.superagi.com"
    : "https://sales.superagi.com",
  iosLink: "supersales://",
  androidPackage: "com.sugeragi.chat",
  storeLinks: {
    ios: "https://apps.apple.com/us/app/supersales-by-superagi/id6667110955",
    android: "https://play.google.com/store/apps/details?id=com.sugeragi.chat",
  },
};

export const apiVariants = {
  OUTREACH: "cold-outreach",
  DASHBOARD: "dashboard",
  WORKFLOWS: "workflows",
  SEQUENCES: "sequences",
  EMAIL_CAMPAIGNS: "email_campaigns",
  PROCESS_FLOWS: "process_design",
  CODER: "coder",
  CODEBASE: "codebase",
  CODE_REVIEWER: "code_reviewer",
  PEOPLE: "people",
  TIME_OFF: "time_off",
  ATTENDANCE: "attendance",
  ATS: "ats",
  PERFORM: "perform",
};

export const mixpanelEmitters = {
  CLIENT: "Client",
  SERVER: "Server",
};

export const appStoreCodes = {
  WHATSAPP: "whatsapp",
  CUSTOMER_SUCCESS: "customer_success",
  DIALER: "dialer",
  MEETINGS: "meetings",
};
